import {DrawContext} from "./context";
import {useState} from "react";
import {useEvent} from "socket.io-react-hooks-advanced";
import {drawing} from "../../components/dummy/dummy";


const DrawProvider = ({children}) => {
    const [draw, setDraw] = useState(drawing);
    useEvent("kh_result", (msg) => {
        setDraw(msg);
    });


    return <DrawContext.Provider value={{draw, setDraw}}>
        {children}
    </DrawContext.Provider>
}

export default DrawProvider;